import { CompanyFormState } from "company/detail/components/models";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import React from "react";

export const postalAddressSection = (
  existingCompany: CompanyFormState,
  sourceCompany: CompanyFormState,
  currentCompany: CompanyFormState,
  setCurrentCompany: (company: CompanyFormState) => void
): MergeFormSection => ({
  key: "postalAddress",
  title: RESX.Company.PostalAddress,
  fields: [{
    key: "companyName",
    label: RESX.Company.CompanyName,
    currentValue: currentCompany.address.postalAddress.companyName,
    existingValue: existingCompany.address.postalAddress.companyName,
    sourceValue: sourceCompany.address.postalAddress.companyName,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          companyName: sourceCompany.address.postalAddress.companyName,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          companyName: existingCompany.address.postalAddress.companyName,
        },
      },
    }),
  }, {
    key: "addressLine1",
    label: RESX.Address.AddressLine + " 1",
    currentValue: currentCompany.address.postalAddress.addressLine1,
    existingValue: existingCompany.address.postalAddress.addressLine1,
    sourceValue: sourceCompany.address.postalAddress.addressLine1,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          addressLine1: sourceCompany.address.postalAddress.addressLine1,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          addressLine1: existingCompany.address.postalAddress.addressLine1,
        },
      },
    }),
  }, {
    key: "addressLine2",
    label: RESX.Address.AddressLine + " 2",
    currentValue: currentCompany.address.postalAddress.addressLine2,
    existingValue: existingCompany.address.postalAddress.addressLine2,
    sourceValue: sourceCompany.address.postalAddress.addressLine2,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          addressLine2: sourceCompany.address.postalAddress.addressLine2,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          addressLine2: existingCompany.address.postalAddress.addressLine2,
        },
      },
    }),
  }, {
    key: "postalCode",
    label: RESX.Address.PostalCode,
    currentValue: currentCompany.address.postalAddress.postalCode,
    existingValue: existingCompany.address.postalAddress.postalCode,
    sourceValue: sourceCompany.address.postalAddress.postalCode,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          postalCode: sourceCompany.address.postalAddress.postalCode,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          postalCode: existingCompany.address.postalAddress.postalCode,
        },
      },
    }),
  }, {
    key: "city",
    label: RESX.Address.City,
    currentValue: currentCompany.address.postalAddress.city,
    existingValue: existingCompany.address.postalAddress.city,
    sourceValue: sourceCompany.address.postalAddress.city,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          city: sourceCompany.address.postalAddress.city,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          city: existingCompany.address.postalAddress.city,
        },
      },
    }),
  }, {
    key: "country",
    label: RESX.Address.Country,
    currentValue: currentCompany.address.postalAddress.country,
    existingValue: existingCompany.address.postalAddress.country,
    sourceValue: sourceCompany.address.postalAddress.country,
    isEmpty: (v) => !v,
    render: (value: server.dto.Country) => <span>{value.name}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          country: sourceCompany.address.postalAddress.country,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          country: existingCompany.address.postalAddress.country,
        },
      },
    }),
  }, {
    key: "state",
    label: RESX.Address.State,
    currentValue: currentCompany.address.postalAddress.state,
    existingValue: existingCompany.address.postalAddress.state,
    sourceValue: sourceCompany.address.postalAddress.state,
    isEmpty: (v) => !v,
    render: (value: server.dto.State) => <span>{value.name}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          state: sourceCompany.address.postalAddress.state,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        postalAddress: {
          ...currentCompany.address.postalAddress,
          state: existingCompany.address.postalAddress.state,
        },
      },
    }),
  }]
});